import type { Template } from "@/types";

export const LA_07_H4_V3: Template[] = [
{
    id: "la-07-h4v3-01",
    name: "LA 01 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 87, y: 85, width: 228, height: 150, rotation: 0, imageRotation: 0 },
            { id: "2", x: 87, y: 242, width: 228, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 85, width: 227, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 322, y: 242, width: 227, height: 150, rotation: 0, imageRotation: 0 },
            { id: "5", x: 742, y: 36, width: 288, height: 402, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1037, y: 36, width: 132, height: 197, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1037, y: 241, width: 132, height: 197, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-02",
    name: "LA 02 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 87, y: 38, width: 463, height: 294, rotation: 0, imageRotation: 0 },
            { id: "2", x: 87, y: 338, width: 150, height: 101, rotation: 0, imageRotation: 0 },
            { id: "3", x: 244, y: 338, width: 149, height: 101, rotation: 0, imageRotation: 0 },
            { id: "4", x: 400, y: 338, width: 149, height: 101, rotation: 0, imageRotation: 0 },
            { id: "5", x: 742, y: 38, width: 288, height: 402, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1037, y: 38, width: 132, height: 198, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1037, y: 243, width: 132, height: 197, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-03",
    name: "LA 03 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 107, y: 49, width: 422, height: 247, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 304, width: 208, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 304, width: 207, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 769, y: 49, width: 373, height: 205, rotation: 0, imageRotation: 0 },
            { id: "5", x: 769, y: 262, width: 120, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 896, y: 262, width: 120, height: 167, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1023, y: 262, width: 119, height: 167, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-04",
    name: "LA 04 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 124, y: 48, width: 125, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 124, y: 241, width: 125, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 257, y: 48, width: 255, height: 380, rotation: 0, imageRotation: 0 },
            { id: "4", x: 729, y: 48, width: 452, height: 264, rotation: 0, imageRotation: 0 },
            { id: "5", x: 729, y: 319, width: 146, height: 108, rotation: 0, imageRotation: 0 },
            { id: "6", x: 883, y: 319, width: 146, height: 108, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1037, y: 319, width: 145, height: 108, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-05",
    name: "LA 05 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 108, y: 48, width: 207, height: 125, rotation: 0, imageRotation: 0 },
            { id: "2", x: 108, y: 181, width: 421, height: 247, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 48, width: 207, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 769, y: 48, width: 373, height: 206, rotation: 0, imageRotation: 0 },
            { id: "5", x: 769, y: 262, width: 120, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 896, y: 262, width: 120, height: 167, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1023, y: 262, width: 119, height: 167, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-06",
    name: "LA 06 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 92, y: 48, width: 452, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 319, width: 146, height: 108, rotation: 0, imageRotation: 0 },
            { id: "3", x: 246, y: 319, width: 146, height: 108, rotation: 0, imageRotation: 0 },
            { id: "4", x: 400, y: 319, width: 145, height: 108, rotation: 0, imageRotation: 0 },
            { id: "5", x: 745, y: 48, width: 271, height: 380, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 48, width: 139, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1024, y: 241, width: 139, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-07",
    name: "LA 07 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 48, width: 555, height: 379, rotation: 0, imageRotation: 0 },
            { id: "2", x: 678, y: 48, width: 183, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 678, y: 177, width: 183, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 307, width: 183, height: 121, rotation: 0, imageRotation: 0 },
            { id: "5", x: 868, y: 48, width: 243, height: 380, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1119, y: 48, width: 115, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1119, y: 242, width: 115, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-08",
    name: "LA 08 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 56, width: 233, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 240, y: 56, width: 269, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 240, y: 242, width: 269, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 516, y: 56, width: 242, height: 363, rotation: 0, imageRotation: 0 },
            { id: "5", x: 766, y: 56, width: 269, height: 178, rotation: 0, imageRotation: 0 },
            { id: "6", x: 766, y: 242, width: 269, height: 177, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1042, y: 56, width: 232, height: 363, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-09",
    name: "LA 09 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 56, width: 269, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 242, width: 269, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 276, y: 56, width: 237, height: 364, rotation: 0, imageRotation: 0 },
            { id: "4", x: 520, y: 56, width: 236, height: 364, rotation: 0, imageRotation: 0 },
            { id: "5", x: 763, y: 56, width: 236, height: 364, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1006, y: 56, width: 268, height: 178, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1006, y: 242, width: 268, height: 178, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h4v3-10",
    name: "LA 10 - H4V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 106, width: 385, height: 265, rotation: 0, imageRotation: 0 },
            { id: "2", x: 393, y: 106, width: 98, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 393, y: 242, width: 98, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 498, y: 106, width: 202, height: 265, rotation: 0, imageRotation: 0 },
            { id: "5", x: 708, y: 106, width: 177, height: 129, rotation: 0, imageRotation: 0 },
            { id: "6", x: 708, y: 242, width: 177, height: 129, rotation: 0, imageRotation: 0 },
            { id: "7", x: 892, y: 106, width: 384, height: 265, rotation: 0, imageRotation: 0 }
    ],
}
];